export type ClerkGetToken = (options?: { template?: string }) => Promise<string | null>;

export const getClerkToken = async (
  getToken: ClerkGetToken,
  template = 'synaptivoice-api'
): Promise<string | null> => {
  if (!getToken) {
    return null;
  }

  try {
    const token = await getToken({ template });
    if (token) {
      return token;
    }
  } catch (error) {
    console.warn('Clerk token template failed; falling back to default token.', error);
  }

  try {
    return await getToken();
  } catch (error) {
    console.warn('Clerk default token failed.', error);
    return null;
  }
};
